import { forwardRef, type ReactNode, type SelectHTMLAttributes } from 'react';
import { Tooltip } from '@localagent/ui/components/tooltip';
import { cn } from '@localagent/ui/lib/utils';

export function SettingsMenuRow({
  label,
  hint,
  children,
}: {
  label: string;
  hint: string;
  children: ReactNode;
}) {
  return (
    <div className="flex w-full items-center justify-between gap-3 rounded px-2 py-1.5 text-caption hover:bg-accent">
      <Tooltip label={hint} side="left" multiline>
        <span tabIndex={0} className="shrink-0 cursor-help focus:outline-none">
          {label}
        </span>
      </Tooltip>
      {children}
    </div>
  );
}

export const SettingsMenuSelect = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function SettingsMenuSelect({ className, ...props }, ref) {
    return (
      <select
        ref={ref}
        {...props}
        className={cn(
          'min-w-0 flex-1 cursor-pointer appearance-none truncate bg-transparent text-right text-caption text-muted-foreground [text-align-last:right] hover:text-foreground focus:outline-none focus-visible:text-foreground disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
      />
    );
  },
);
